// extracted by mini-css-extract-plugin
module.exports = {"root":"RatioContainer_root__139Oz","inner":"RatioContainer_inner__32RWf"};